/**
 * atom-ga4-gap-events.js
 * ---------------------
 * Theme-level GA4 instrumentation for events the Customer Events
 * custom pixel CANNOT send (sandbox blocks outbound to google-analytics.com).
 *
 * Fires:
 *   - view_item_list  (collection pages + search results)
 *   - view_cart        (cart page load + cart drawer open)
 *
 * Transport: the consent-aware main-window bridge in theme.liquid. Events are
 * sent only after analytics consent exists.
 *
 * NEVER fire from this file:
 *   view_item, add_to_cart, begin_checkout, add_payment_info, purchase
 *   — the app pixel emits those; double-firing corrupts revenue data.
 *
 * All events include  send_to: 'G-0MDTFMBPCG'  to prevent fan-out to the
 * Google Ads tag (AW-476970591) which would pollute Ads with bogus events.
 */
(function () {
  'use strict';

  /* Double-run guard — script loads site-wide from theme.liquid; bail if a
     section/template ever includes it a second time (prevents double-firing). */
  if (window.__atomGa4GapEvents) return;
  window.__atomGa4GapEvents = true;

  /* ── consent-aware transport ────────────────────────────── */
  var GA4_ID = 'G-0MDTFMBPCG';

  function sendEvent(name, params) {
    if (typeof window.__atomGa4Send !== 'function') return false;
    params = params || {};
    params.send_to = GA4_ID;
    return window.__atomGa4Send(name, params);
  }

  function merchantItemId(productId, variantId, fallback) {
    if (productId && variantId) {
      return 'shopify_GB_' + String(productId) + '_' + String(variantId);
    }
    return fallback || String(variantId || '');
  }

  /* ── view_item_list ──────────────────────────────────────── */
  function fireViewItemList() {
    var el = document.querySelector('script[data-atom-ga4-list]');
    if (!el) return;

    var data;
    try {
      data = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.items || !data.items.length) return;

    var payload = {
      currency: 'GBP',
      item_list_id: String(data.item_list_id || ''),
      item_list_name: data.item_list_name || '',
      items: data.items,
      send_to: GA4_ID
    };
    if (data.search_term) payload.search_term = data.search_term;

    sendEvent('view_item_list', payload);
  }

  /* ── view_cart ───────────────────────────────────────────── */
  var lastViewCart = 0;
  var VIEW_CART_THROTTLE = 2000; // ms — max one event per 2s

  function fireViewCart() {
    var now = Date.now();
    if (now - lastViewCart < VIEW_CART_THROTTLE) return;
    lastViewCart = now;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;

        var items = cart.items.map(function (it, i) {
          return {
            item_id: merchantItemId(it.product_id, it.variant_id, it.sku),
            item_name: it.product_title,
            price: it.price / 100,
            quantity: it.quantity,
            index: i,
            item_brand: it.vendor || 'ATOM LED'
          };
        });

        sendEvent('view_cart', {
          currency: 'GBP',
          value: cart.total_price / 100,
          items: items
        });
      })
      .catch(function () { /* silent — analytics must never break UX */ });
  }

  /* ── cart drawer open observer ────────────────────────────── */
  function observeCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.attributeName !== 'class') continue;
        if (drawer.classList.contains('active')) {
          fireViewCart();
          return;
        }
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── init ────────────────────────────────────────────────── */
  function init() {
    // view_item_list: fire once on collection/search page load
    fireViewItemList();

    // view_cart: fire on cart page load (detected by data attribute on body/section)
    if (document.querySelector('[data-atom-cart]')) {
      fireViewCart();
    }

    // view_cart: fire when cart drawer opens (class 'active' added)
    observeCartDrawer();
  }

  // Run after DOM is interactive
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
